import React from 'react';
import { Box } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import { AppButton } from '@client/foundation/design-system/components';
import { SharedResourceTabs } from '@client/features/shared-resources/shared-resource-tabs';
import type { TemplateType } from '@server/trading-templates/schemas/input.schema';
import { TemplateGrid } from './template-grid';

type TemplateBuilderPanelProps = {
  templateType: TemplateType;
  isLoading: boolean;
  onNew: () => void;
  onDelete: (templateIds: string[]) => void;
  onSetAsDefault: (templateId: string, isDefault: boolean) => void;
  onModify?: (templateId: string, templateName: string) => void;
  onDuplicate?: (templateId: string, templateName: string) => void;
  onShare?: (templateId: string, templateName: string) => void;
  onImportShared: (
    sharedResourceId: string,
    sharedResourceName: string
  ) => void;
  onModifyShared?: (
    sharedResourceId: string,
    sharedResourceName: string
  ) => void;
  onRevokeShared?: (sharedResourceId: string) => void;
};

export const TemplateBuilderPanel: React.FC<TemplateBuilderPanelProps> = ({
  templateType,
  isLoading,
  onNew,
  onDelete,
  onSetAsDefault,
  onModify,
  onDuplicate,
  onShare,
  onImportShared,
  onModifyShared,
  onRevokeShared
}) => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        gap: 3,
        height: '100%',
        minHeight: 0,
        mt: 1
      }}
    >
      <Box sx={{ display: 'flex', justifyContent: 'flex-end', mb: 1.5 }}>
        <AppButton
          tone="primary"
          onClick={onNew}
          startIcon={<AddIcon />}
        >
          New
        </AppButton>
      </Box>

      <Box
        sx={{
          opacity: isLoading ? 0.7 : 1,
          flex: 1,
          minHeight: 0
        }}
      >
        <SharedResourceTabs
          sharedResourceType="template"
          sharedTemplateType={templateType}
          onImportShared={onImportShared}
          onModifyShared={onModifyShared}
          onRevokeShared={onRevokeShared}
          renderMine={() => (
            <TemplateGrid
              templateType={templateType}
              onDelete={onDelete}
              onSetAsDefault={onSetAsDefault}
              onModify={onModify}
              onDuplicate={onDuplicate}
              onShare={onShare}
            />
          )}
        />
      </Box>
    </Box>
  );
};
